import { render, staticRenderFns } from "./group-owner.vue?vue&type=template&id=3d1fcc14&"
import script from "./group-owner.vue?vue&type=script&lang=js&"
export * from "./group-owner.vue?vue&type=script&lang=js&"
import style0 from "./group-owner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-cli-build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports